const mrpScheduledPurchaseHeader = [
  {
    group: 'Centro',
    columns: [
      {
        name: 'Código',
        id: 'centro-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'centro-nome',
        show: false
      }
    ]
  },
  {
    group: 'Produto',
    columns: [
      {
        name: 'Código',
        id: 'produto-id',
        show: true
      },
      {
        name: 'Material',
        id: 'produto-material',
        show: true
      },
      {
        name: 'Categoria Compacta',
        id: 'produto-categoria-compacta',
        show: true
      },
      {
        name: 'Categoria',
        id: 'produto-categoria',
        show: false
      },
      {
        name: 'Mundo',
        id: 'produto-mundo',
        show: false
      },
      {
        name: 'Curva ABC',
        id: 'produto-curva-abc',
        show: false
      },
      {
        name: 'Curva ABC Empresa',
        id: 'produto-curva-abc-empresa',
        show: false
      },
      {
        name: 'Status',
        id: 'produto-status',
        show: false
      },
      {
        name: 'Lote',
        id: 'produto-lote',
        show: false
      },
      {
        name: 'Grupo Separação',
        id: 'produto-grupo-separacao',
        show: false
      }
    ]
  },
  {
    group: 'Fornecedor',
    columns: [
      {
        name: 'Código',
        id: 'fornecedor-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'fornecedor-nome',
        show: true
      }
    ]
  },
  {
    group: 'Recomendação Programada',
    columns: [
      {
        name: 'Quantidade',
        id: 'recomendacao-quantidade',
        show: true
      },
      {
        name: 'Peso',
        id: 'recomendacao-peso',
        show: false
      },
      {
        name: 'Volume',
        id: 'recomendacao-volume',
        show: false
      },
      {
        name: 'Custo',
        id: 'recomendacao-custo',
        show: true
      },
      {
        name: 'Tipo Alerta',
        id: 'recomendacao-tipo-alerta',
        show: false
      },
      {
        name: 'Nível Serviço %',
        id: 'recomendacao-nivel-servico',
        show: false
      },
      {
        name: 'Data Início',
        id: 'recomendacao-inicio',
        show: true
      },
      {
        name: 'Data Fim',
        id: 'recomendacao-fim',
        show: true
      }
    ]
  },
  {
    group: 'Compra Programada',
    columns: [
      {
        name: 'Quantidade Desejada',
        id: 'compra-desejada',
        show: true,
        editable: true
      },
      {
        name: 'Peso',
        id: 'compra-peso',
        show: false
      },
      {
        name: 'Volume',
        id: 'compra-volume',
        show: false
      },
      {
        name: 'Custo',
        id: 'compra-custo',
        show: true
      },
      {
        name: 'Custo Unit.',
        id: 'compra-custo-unit',
        show: false
      },
      {
        name: 'Nível Serviço %',
        id: 'compra-nivel-servico',
        show: false
      },
      {
        name: 'Data Início',
        id: 'compra-inicio',
        show: true
      },
      {
        name: 'Data Fim',
        id: 'compra-fim',
        show: true
      }
    ]
  },
  {
    group: 'Simulação DRP',
    columns: [
      {
        name: 'Demanda Média Diária',
        id: 'simulacao-demanda-media',
        show: true
      },
      {
        name: 'Cobertura Média',
        id: 'simulacao-cobertura-media',
        show: true
      },
      {
        name: 'Número de Pedidos',
        id: 'simulacao-numero-pedidos',
        show: false
      }
    ]
  },
  {
    group: 'Estoque',
    columns: [
      {
        name: 'Disponível',
        id: 'estoque-disponivel',
        show: true
      },
      {
        name: 'Reservado',
        id: 'estoque-reservado',
        show: false
      },
      {
        name: 'CD',
        id: 'estoque-cd',
        show: false
      },
      {
        name: 'Máximo',
        id: 'estoque-max',
        show: false
      },
      {
        name: 'Mínimo',
        id: 'estoque-minimo',
        show: false
      },
      {
        name: 'Ordenado',
        id: 'estoque-ordenado',
        show: false
      },
      {
        name: 'Total',
        id: 'estoque-total',
        show: false
      },
      {
        name: 'Total + Ordenado',
        id: 'estoque-total-ordenado',
        show: false
      },
      {
        name: 'Período Revisão',
        id: 'estoque-periodo-revisao',
        show: false
      },
      {
        name: 'Tempo Espera',
        id: 'estoque-tempo-espera',
        show: false
      }
    ]
  },
  {
    group: 'Cobertura',
    columns: [
      {
        name: 'Cobertura Alvo',
        id: 'cobertura-alvo',
        show: false
      },
      {
        name: 'Cobertura Desejada',
        id: 'cobertura-desejada',
        show: false
      },
      {
        name: 'Diferença',
        id: 'diferenca',
        show: false
      },
      {
        name: 'Alcançou Recomendação',
        id: 'alcancou-recomendacao',
        show: false
      },
      {
        name: 'Acima Tolerância',
        id: 'acima-tolerancia',
        show: false
      }
    ]
  }
]

export default mrpScheduledPurchaseHeader
